// User core model
import { z } from 'zod';

import type { OperatorStatus } from '@/models/OperatorStatus.ts';
import type { Organization } from '@/models/Organization.ts';
import type { Role } from '@/models/Role.ts';

const UserDeviceInnerSchema = z.object({
  authType: z.string(),
  deviceId: z.string(),
  password: z.string(),
  deviceType: z.string(),
  description: z.string(),
});

const UserDeviceSchema = z.object({
  deviceId: z.string(),
  deviceName: z.string(),
  deviceType: z.string(),
  deviceStatus: z.string(),
  deviceModel: z.string(),
  deviceLocation: z.string(),
  iotcommsDevice: UserDeviceInnerSchema,
});

export const UserSchema = z.object({
  id: z.string(),
  organization: z.custom<Organization>(),
  roles: z.array(z.custom<Role>()),
  accessToken: z.string(),
  expiresTime: z.string(),
  refreshToken: z.string(),

  userName: z.string(),
  status: z.custom<OperatorStatus>(),
  device: UserDeviceSchema.nullable().optional(),
});

export type User = z.infer<typeof UserSchema>;
